    import {MenuIconType} from './menu-icon-type';

export class Menu {

    menu_type: string = 'MENU0001';
    menu_has_header: boolean = false;
    menu_header_type: string;
    menu_content_mandatory_list = new Array<string>();
    menu_youtube_url: string;

    menu_has_custom_bg: boolean = false;
    menu_bg_type = 'BG001';
    menu_bg_color: string = null;
    menu_bg_image_type: string;
    menu_bg_image_id: string;
    menu_bg_image_has_blur: boolean = false;
    menu_bg_image_blur_index: number;

    menu_icon_remove_card: boolean = false;
    
    menu_icon_card_color: string = null;
    menu_icon_text_color: string = null;
    menu_icon_color: string = 'DEFAULT';

    has_custom_card_color: boolean = false;
    has_custom_icon_color: boolean = false;
    has_custom_icon_text_color: boolean = false;
    

//    menuIconType:MenuIconType = MenuIconType.NORMAL;
    menuIconType:string  =  "NORMAL";
    
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/menu.ts